import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "leaderboard-entry pagination" }
const _hoisted_2 = ["disabled"]
const _hoisted_3 = { key: 0 }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = { key: 0 }

import { PropType } from 'vue';
import IconComponent from '@/components/IconComponent.vue';
import IconArrowRight from '@/assets/VueIcons/IconArrowRight.vue';
import { isPhone } from '@/utils/responsiveHelper';
import IconArrowLeft from '@/assets/VueIcons/IconArrowLeft.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'PaginationComponent',
  props: {
  currentPage: Number,
  totalPages: Number,
  onBack: Function as PropType<(event: MouseEvent) => void>,
  onNext: Function as PropType<(event: MouseEvent) => void>
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("li", _hoisted_1, [
    _createElementVNode("button", {
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (__props.onBack && __props.onBack(...args))),
      disabled: __props.currentPage === 1,
      class: "pagination-button"
    }, [
      (!_unref(isPhone)())
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, "Previous"))
        : (_openBlock(), _createBlock(IconComponent, { key: 1 }, {
            default: _withCtx(() => [
              _createVNode(IconArrowLeft)
            ]),
            _: 1
          }))
    ], 8, _hoisted_2),
    _createElementVNode("p", null, "Page " + _toDisplayString(__props.currentPage) + " of " + _toDisplayString(__props.totalPages), 1),
    _createElementVNode("button", {
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (__props.onNext && __props.onNext(...args))),
      disabled: __props.currentPage === __props.totalPages,
      class: "pagination-button"
    }, [
      (!_unref(isPhone)())
        ? (_openBlock(), _createElementBlock("span", _hoisted_5, "Next"))
        : (_openBlock(), _createBlock(IconComponent, { key: 1 }, {
            default: _withCtx(() => [
              _createVNode(IconArrowRight)
            ]),
            _: 1
          }))
    ], 8, _hoisted_4)
  ]))
}
}

})